import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ConfigElement, ConfigNanoGrid, Element, Page, Survey} from '../models/config-nanogrid.model';
import jsonSurvey from '../../../../assets/config-nanogrid/survey.json';
import { DataService } from 'src/app/shared/services/data.service';



@Component({
    selector: 'app-show-config',
    templateUrl: './show-config.component.html',
    styleUrls: ['./show-config.component.scss']
})
export class ShowConfigComponent implements OnInit {

    @Input() config: ConfigNanoGrid;

    survey: Survey = jsonSurvey;

    constructor(private dataService: DataService){}

    ngOnInit() {
        if (this.survey.pages && this.survey.pages.length > 0) {
            this.survey.pages.forEach((page: Page) => {
                if (page.elements && page.elements.length > 0) {
                    // @ts-ignore
                    page.elements.forEach((element: Element) => {
                        {
                            const value = this.findValue(page.name, element.name);
                            if (value) {
                                element.value = value;
                            }
                        }

                        if (element.columns && element.columns.length > 0) {
                            element.columns.forEach((column: Element) => {
                                const value = this.findValue(page.name, `${element.name}-${column.name}`);
                                if (value) {
                                    element.value = value;
                                }
                            });
                        }
                    });
                }
            });
        }
    }

    findValue(page: string, name: string): string {
        const el = this.config[page] ? (this.config[page] as ConfigElement[]).filter(e => e.name === name)[0] : null;

        return el ? el.value : null;
    }
}
